import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/Admin/Dashboard/Dashboard";
import Login from "./pages/Login/Login";
import AdCallRecords from "./pages/Admin/AdCallRecords/AdCallRecords";
import Header from "./Layout/Header/Header";
import SideMenu from "./Layout/Menu/SideMenu/SideMenu"
import AdMentor from "./pages/Admin/AdMentor/AdMentor";
import AddMentor from "./pages/Admin/AdMentor/AddMentor/AddMentor";
import AdMentee from "./pages/Admin/AdMentee/AdMentee";
import AdMentorRequest from "./pages/Admin/AdMentorRequest/AdMentorRequest";
import AdMentorsProfile from "./pages/Admin/AdMentorsProfile/AdMentorsProfile";
import AdMenteeProfile from './pages/Admin/AdMenteeProfile/AdMenteeProfile'
import AdMyProfile from './pages/Admin/AdMyProfile/AdMyProfile'
import AllNotifications from "./pages/Admin/AllNotifications/AllNotifications";
import MnCallRecords from "./pages/Mentor/MnCallRecords/MnCallRecords";
import MnMyProfile from "./pages/Mentor/MnMyProfile/MnMyProfile";
import MnDashboard from "./pages/Mentor/MnDashboard/MnDashboard";
import MnMenteeProfile from "./pages/Mentor/MnMenteeProfile/MnMenteeProfile";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import MeDashboard from "./pages/Mentee/MeDashboard/MeDashboard";
import MeCallRecords from "./pages/Mentee/MeCallRecords/MeCallRecords";
import MentorProfile from "./pages/Mentee/MentorProfile/MentorProfile";
import MeMyProfile from "./pages/Mentee/MeMyProfile/MeMyProfile";
import AllMentors from "./pages/Mentee/AllMentors/AllMentors";
import Earnings from "./pages/Mentor/Earnings/Earnings";
import { AdminPrivateRoute } from "./helpers/AdminPrivateRoute";
import { NoRouteFound } from "./helpers/NoRouteFound";
import { MentorPrivateRoute } from "./helpers/MentorPrivateRoute";
import { MenteePrivateRoute } from "./helpers/MenteePrivateRoute";
import { useState } from "react";
import AdBilling from "./pages/Admin/AdBilling/AdBilling";
import AdBillingchart from "./pages/Admin/AdBilling/AdBillingchart";
import Eventstest from "./pages/Admin/Events/Eventstest";
import Events from "./pages/Admin/Events/Events";
import MentorFeedback from "./pages/Mentor/MnFeedBackForm/MentorFeedback";
import MenteeFeedback from "./pages/Mentee/MeFeedBackForm/MenteeFeedback";
import ChangePassword from "./pages/Login/ChangePassword";

function App() {

  const { pathname } = useLocation();
  const [onClickMenu, setOnClickMenu] = useState(false);


  return (
    <>
      <div className="appContainer">
        {((pathname !== '/login' && pathname.split("/")[1] !== 'changePassword') && pathname.split("/")[1] !== "mentor-feedback" && pathname.split("/")[1] !== "mentee-feedback") && <SideMenu onClickMenu={onClickMenu} setOnClickMenu={setOnClickMenu} />}
        <div className={`routesContainer  ${((pathname === '/login' || pathname.split("/")[1] === 'changePassword') || pathname.split("/")[1] === "mentor-feedback" || pathname.split("/")[1] === "mentee-feedback") ? 'scrollingBG' : ''}`}>
          {((pathname !== '/login' && pathname.split("/")[1] !== 'changePassword') && pathname.split("/")[1] !== "mentor-feedback" && pathname.split("/")[1] !== "mentee-feedback") && <Header onClickMenu={onClickMenu} setOnClickMenu={setOnClickMenu} />}
          <div className="mainWrapper">
            <Routes>
              <Route path="*" element={<NoRouteFound />} />
              <Route path="/login" exact element={<Login />} />
              <Route path="/changePassword/:token" exact element={<ChangePassword />} />
              <Route path="mentor-feedback/:feedbackId" element={<MentorFeedback />} />
              <Route path="mentee-feedback/:feedbackId" element={<MenteeFeedback />} />
              {/* Admin */}
              <Route exact path="/admin" element={<AdminPrivateRoute />} >
                <Route path="*" exact element={<PageNotFound />} />
                <Route path="" exact element={<Dashboard />} />
                <Route path="call-records" exact element={<AdCallRecords />} />
                <Route path="all-mentor" exact element={<AdMentor />} />
                <Route path="add-mentor" exact element={<AddMentor />} />
                <Route path="all-mentee" exact element={<AdMentee />} />
                <Route path="mentor-request" exact element={<AdMentorRequest />} />
                <Route path="mentor-profile/:userId" exact element={<AdMentorsProfile />} />
                <Route path="mentee-profile/:userId" exact element={<AdMenteeProfile />} />
                <Route path="my-profile" exact element={<AdMyProfile />} />
                <Route path="all-notification" exact element={<AllNotifications />} />
                <Route path="events" exact element={<Events />} />
                <Route path="event-details/:eventId" exact element={<Eventstest />} />
                <Route path="Billing" exact element={<AdBilling />} />
                <Route path="Billingchart" exact element={<AdBillingchart />} />
              </Route>

              {/* Mentor */}
              <Route exact path="/mentor" element={<MentorPrivateRoute />} >
                <Route path="*" exact element={<PageNotFound />} />
                <Route path="" exact element={<MnDashboard />} />
                <Route path="call-records" exact element={<MnCallRecords />} />
                <Route path="my-profile" exact element={<MnMyProfile />} />
                <Route path="mentee-profile/:userId" exact element={<MnMenteeProfile />} />
                <Route path="Earnings" exact element={<Earnings />} />
              </Route>

              {/* Mentee */}
              <Route path="/mentee" exact element={<MenteePrivateRoute />} >
                <Route path="*" exact element={<PageNotFound />} />
                <Route path="" exact element={<MeDashboard />} />
                <Route path="call-records" exact element={<MeCallRecords />} />
                <Route path="mentor-profile/:userId" exact element={<MentorProfile />} />
                <Route path="my-profile" exact element={<MeMyProfile />} />
                <Route path="all-mentor" exact element={<AllMentors />} />
              </Route>
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
